import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Get, Put, Post } from 'utils/axios'
import { requestError, requestSuccess } from 'utils/requestHandler'

const HOC = ( WrappedComponent ) => {
  class WithHOC extends Component {
    state = {
      loading: false,
      forms: [],
      selectedForm: {},

      showCreateModal: false,
      showUpdateModal: false
    }

    onChangeFormHOC = ( key, val ) => this.setState({ [key]: val })

    load = param => this.setState({ loading: param })

    getForms = () => Get(
      `/default_forms`,
      this.getFormsSuccess,
      this.getFormsError,
      this.load
    )
    getFormsSuccess = payload => this.setState({ forms: payload })
    getFormsError = error => requestError( error )

    getSelectedForm = id => Get(
      `/default_forms/${ id }`,
      this.getSelectedFormSuccess,
      this.getSelectedFormError,
      this.load
    )
    getSelectedFormSuccess = payload => this.setState({ 
      selectedForm: payload,
      showUpdateModal: true
    })
    getSelectedFormError = error => requestError ( error )

    createForm = dataToSubmit => Post(
      `/default_forms`,
      dataToSubmit,
      this.createFormSuccess,
      this.createFormError,
      this.load
    )
    createFormSuccess = () => {
      requestSuccess( 'Form has been created successfully.' )
      this.getForms()
      this.setState({ showCreateModal: false })
    }
    createFormError = error => requestError( error )

    updateForm = dataToSubmit => Put(
      `/default_forms/${ dataToSubmit.id }`,
      dataToSubmit,
      this.updateFormSucces,
      this.updateFormError,
      this.load
    )
    updateFormSucces = payload => {
      this.getSelectedForm( payload.id )
      requestSuccess( 'Form has been updated successfully.' )
    }
    updateFormError = error => requestError( error )

    render = () => {
      return (
        <WrappedComponent
          { ...this.props } 
          forms={ this.state.forms }
          selectedForm={ this.state.selectedForm }
          onLoadForms={ this.state.loading }
          showUpdateModal={ this.state.showUpdateModal }
          showCreateModal={ this.state.showCreateModal }

          getForms={ this.getForms }
          getSelectedForm={ this.getSelectedForm }
          updateForm={ this.updateForm }
          createForm={ this.createForm }
          onChangeFormHOC={ this.onChangeFormHOC }
        />
      )
    }
  }
  const mapStateToProps = state => ({ data: state })
  return connect( mapStateToProps )( WithHOC )
}

export default HOC